/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Takeofflinedescription2Inputs */

const en_takeofflinedescription2 = /** @type {(inputs: Takeofflinedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nobody can find it until you publish it again.`)
};

const de_takeofflinedescription2 = /** @type {(inputs: Takeofflinedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niemand findet es dann mehr, bis du es wieder veröffentlichst.`)
};

/**
* | output |
* | --- |
* | "Nobody can find it until you publish it again." |
*
* @param {Takeofflinedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const takeofflinedescription2 = /** @type {((inputs?: Takeofflinedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Takeofflinedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_takeofflinedescription2(inputs)
	return de_takeofflinedescription2(inputs)
});
export { takeofflinedescription2 as "takeOfflineDescription" }